import { useState } from 'react';
import { Box, Button, DialogActions, TextField } from '@mui/material';
import { useDispatch } from 'react-redux';
import { saveNote } from '../../../../store/incidentsReducer';

export default function NoteForm({ incidentId, onCancel, onSaved, note }) {
  const dispatch = useDispatch();
  const [newNote, setNewNote] = useState(note?.note || '');
  const [isLoading, setIsLoading] = useState(false);

  const handleSaveNote = () => {
    setIsLoading(true);
    dispatch(saveNote(incidentId, newNote, note?.id)).then((resp) => {
      setIsLoading(false);
      if (resp) {
        onSaved?.();
      }
    });
  };

  return (
    <Box>
      <TextField
        value={newNote}
        onChange={(e) => setNewNote(e.target.value)}
        fullWidth
        variant="outlined"
        multiline
        rows={6}
        size="small"
      />
      <DialogActions>
        <Button variant="outlined" className="actionButton" onClick={onCancel}>
          Cancel
        </Button>
        <Button
          variant="contained"
          className="actionButton ms-2"
          disabled={isLoading}
          onClick={handleSaveNote}
        >
          {isLoading ? 'Saving...' : 'Save'}
        </Button>
      </DialogActions>
    </Box>
  );
}
